<template>
  <div
    :style="{ 'min-height': `${minHeight}px` }"
    :class="[
      'quadro-principal',
      classe,
      `borda-esquerda-${classe}`,
      { borderTop: borderTop },
      { loading: loading }
    ]"
  >
    <div :class="['borda-arredondada', `borda-direita-${classe}`]" />
    <h2 :key="getRenderKey" :class="['titulo-lateral', imprimeTitulo]">{{ titulo }}</h2>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "QuadroPrincipal",

  props: {
    classe: String,
    titulo: String,
    borderTop: Boolean,
    loading: Boolean
  },

  data() {
    return {};
  },

  mounted() {},

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    minHeight() {
      if (this.titulo) {
        return this.titulo.length * 10;
      }
      return 0;
    },
    imprimeTitulo() {
      switch (this.titulo) {
        case "PREFERENCIA TARIFÁRIA":
          return "no-print";
        case "IMPOSTO DE EXPORTAÇÃO":
          return "no-print";
        case "IMPOSTO DE IMPORTAÇÃO":
          return "no-print";
        case "DEFESA COMERCIAL":
          return "no-print";
        case "IPI":
          return "no-print";
        case "PIS COFINS":
          return "no-print";
        case "CIDE COMBUSTÍVEL":
          return "no-print";
        case "ICMS":
          return this.classe == "icms_interno" ? "no-print" : "";
        case "ICMS ST":
          return "no-print";
        default:
          return;
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.quadro-principal {
  position: relative;
  min-height: 130px;
  height: fit-content;
  border-left: 30px solid;
  border-right: 3px solid;
  border-bottom: 3px solid;
  padding: 10px 10px 10px 6px;
  &:last-child {
    border-radius: 0 0 10px 10px;
  }
  &::before {
    content: "";
    background: transparent;
    height: 10px;
    width: 10px;
    top: -1px;
    left: -1px;
    position: absolute;
    border-radius: 50px 0 0 0;
  }
  &::after {
    content: "";
    background: transparent;
    height: 10px;
    width: 10px;
    bottom: -1px;
    left: -1px;
    position: absolute;
    border-radius: 0 0 0 50px;
  }
}
.borda-arredondada {
  &::before {
    content: "";
    background: transparent;
    height: 10px;
    width: 10px;
    top: -1px;
    right: -1px;
    position: absolute;
    border-radius: 0 50px 0 0;
  }
  &::after {
    content: "";
    background: transparent;
    height: 10px;
    width: 10px;
    bottom: -1px;
    right: -1px;
    position: absolute;
    border-radius: 0 0 50px 0;
  }
}
.borda-esquerda-ipi {
  &::before {
    box-shadow: -1px -1px 0 1px var(--ipi);
  }
  &::after {
    box-shadow: -1px 1px 0 1px var(--ipi);
  }
}

.borda-esquerda-exportacao,
.borda-esquerda-preferencia_tarifaria,
.borda-esquerda-class_importacao,
.borda-esquerda-defesa_comercial {
  &::before {
    box-shadow: -1px -1px 0 1px var(--importacao);
  }
  &::after {
    box-shadow: -1px 1px 0 1px var(--importacao);
  }
}

.borda-esquerda-pis_cofins,
.borda-esquerda-cide_combustivel {
  &::before {
    box-shadow: -1px -1px 0 1px var(--pis-cofins);
  }
  &::after {
    box-shadow: -1px 1px 0 1px var(--pis-cofins);
  }
}

.borda-esquerda-icms_interno,
.borda-esquerda-icms_st,
.borda-esquerda-carga_liquida,
.borda-esquerda-difal,
.borda-esquerda-antecipacao {
  &::before {
    box-shadow: -1px -1px 0 1px var(--icms);
  }
  &::after {
    box-shadow: -1px 1px 0 1px var(--icms);
  }
}
.borda-direita-ipi {
  &::before {
    box-shadow: 1px -1px 0 1px var(--ipi);
  }
  &::after {
    box-shadow: 1px 1px 0 1px var(--ipi);
  }
}

.borda-direita-exportacao,
.borda-direita-preferencia_tarifaria,
.borda-direita-class_importacao,
.borda-direita-defesa_comercial {
  &::before {
    box-shadow: 1px -1px 0 1px var(--importacao);
  }
  &::after {
    box-shadow: 1px 1px 0 1px var(--importacao);
  }
}

.borda-direita-pis_cofins,
.borda-direita-cide_combustivel {
  &::before {
    box-shadow: 1px -1px 0 1px var(--pis-cofins);
  }
  &::after {
    box-shadow: 1px 1px 0 1px var(--pis-cofins);
  }
}

.borda-direita-icms_interno,
.borda-direita-icms_st,
.borda-direita-carga_liquida,
.borda-direita-difal,
.borda-direita-antecipacao {
  &::before {
    box-shadow: 1px -1px 0 1px var(--icms);
  }
  &::after {
    box-shadow: 1px 1px 0 1px var(--icms);
  }
}
.loading {
  padding: 0;
}

.borderTop {
  border-top: 3px solid;
  border-radius: 10px 10px 0 0;
  &:last-child {
    border-radius: 10px;
  }
}

.titulo-lateral {
  all: unset;
  position: absolute;
  transform: scaleX(-1) scaleY(-1);
  writing-mode: vertical-rl;
  color: var(--branco);
  left: -22px;
  top: 0;
  height: 100%;
  font-weight: bold;
  margin: 0;
  white-space: nowrap;
  text-align: center;
}

.ipi {
  border-color: var(--ipi);
}

.exportacao,
.preferencia_tarifaria,
.class_importacao,
.defesa_comercial {
  border-color: var(--importacao);
}

.pis_cofins,
.cide_combustivel {
  border-color: var(--pis-cofins);
}

.icms_interno,
.icms_st,
.carga_liquida,
.difal,
.antecipacao {
  border-color: var(--icms);
}

@media only print {
  .quadro-principal {
    position: relative;
    min-height: 130px;
    height: fit-content;
    border: none;
    padding: none;
    padding-top: 0;
    // page-break-after: avoid;
    page-break-inside: avoid;
  }
  .titulo-lateral {
    all: unset;
    // display: none;
    font-weight: bold;
    margin: 0;
    white-space: nowrap;
    text-align: center;
    // page-break-after: avoid;

    // position: absolute;
    // transform: scaleX(-1) scaleY(-1);
    // writing-mode: vertical-rl;
    // left: -11px;
    // top: 20px;
    // height: 100px;
    // border: 1px solid var(--preto);
  }
}
</style>
